import React from 'react'

import IconButton from '@mui/material/IconButton'

import CloseIcon from '@mui/icons-material/Close'

import Modal from 'components/common/Modal'
import NotificationPreview from '../NotificationPreview'

function NotificationPreviewModal({ open, onClose, notification }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      width="900px"
      height="95vh"
      scrollable={false}
      hideButtonsBorder
    >
      {/* Close Button */}
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          top: 4,
          right: 4,
          zIndex: 1,
        }}
      >
        <CloseIcon />
      </IconButton>

      <NotificationPreview documentId={notification?.id} />
    </Modal>
  )
}

export default NotificationPreviewModal
